// NPM Modules
import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import RaceBetType from '@/Models/RaceBetType.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		updateRaceBetTypes(raceId, data) {
			const raceBetType = new RaceBetType();

			return raceBetType.update(raceId, data);
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
